import { useQuery } from "@tanstack/react-query";
import { getPostCategoryById } from "../../../api/apiBlog";
import i18next from "i18next";

export const useGetPostCategoryById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["post-category", id, i18next.language],
        queryFn: () => getPostCategoryById(id),
        enabled: !!id,
    });

    return {
        category: data?.data,
        isLoading,
        error,
        refetch,
    };
};
